const { convertArrayToCSV } = require('convert-array-to-csv');
var _ = require('underscore');
import exportExcerptHelper from './ExportExcerptHelper'
import exportNameMapper from './ExportNameMapper'

import {
  TRANSCRIPT,
  SNIPPET,
  URL,
  MEMOS,
  CODED_BY,
  CODES,
  SURVEY_QUESTION,
  SURVEY_RESPONDANT_NAME
} from './ExportConstants'

const HEADER = [TRANSCRIPT, SNIPPET, URL, MEMOS, CODED_BY, SURVEY_QUESTION, SURVEY_RESPONDANT_NAME]

const exportExcerptMapper = (projectData, excerpts, descriptors, codesData, usersData, transcripts, selectionsData) => {
  let exportExcerpts;
  let descriptorNames = [];

  try {
    const exportObjects = exportExcerptHelper(excerpts, descriptors, codesData, usersData, transcripts, selectionsData);
    const processedExcerpts = exportObjects.excerpts;
    descriptorNames = exportObjects.descriptorNames;
    
    exportExcerpts = processedExcerpts.map((excerpt) => {
      return [
        excerpt.start || 0,
        excerpt.survey_title || excerpt.transcriptName,
        excerpt.text,
        excerpt.url,
        excerpt.memos,
        excerpt.coders,
        excerpt.survey_question_text || '',
        excerpt.survey_row_text || '',
        ...excerpt.choices,
        ...excerpt.codeNames
      ];
    }).sort(function (a, b) {
      const aName = a[1].toLowerCase();
      const bName = b[1].toLowerCase();
      const localeCompare = aName.localeCompare(bName);
      if (localeCompare != 0) return localeCompare;
      return (a[0] < b[0]) ? -1 : 1;
    }).map((excerptArray) =>
      _.rest(excerptArray)
    );
  } catch (e) {
    console.error(e);
    exportExcerpts = [];
  }

  // Same date prefix as every other export (UTC); this one used the local
  // date, so its filename disagreed with the matrix exports in the evening.
  const exportFileName = exportNameMapper(projectData?.name, 'Snippets', 'Project');

  return {
    projectName: exportFileName,
    exportExcerpts: convertArrayToCSV(
      exportExcerpts,
      {
        separator: ',',
        header: [...HEADER, ...descriptorNames, CODES]
      }
    )
  }
}

export default exportExcerptMapper